import { Injectable } from "@angular/core";
import { DashboardService } from "../dashboard.service";
import { BehaviorSubject } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { AlertService } from "../../alert.service";
import { StorageService } from "../../storage.service";
import { RetentionMiscDataAPIResponse } from "../../../../app/_models";

@Injectable({
  providedIn: "root",
})
export class RetentionMiscDataService extends DashboardService {
  route = "retention_dashboard/retention_miscellaneous_cards";
  emptyResponse = {
    customers_saved: 0,
    customers_cancelled: 0,
    path_breakdown: [],
    survey_responses: [],
    cancel_categories: [],
  };
  protected data: BehaviorSubject<RetentionMiscDataAPIResponse> =
    new BehaviorSubject<RetentionMiscDataAPIResponse>(this.emptyResponse);
  constructor(
    protected http: HttpClient,
    protected alertService: AlertService,
    protected storageService: StorageService
  ) {
    super(http, alertService, storageService);
  }

  getData() {
    if (!this.route) {
      return;
    }

    this.http.post(this.route + "/", this.getBody()).subscribe(
      (data: RetentionMiscDataAPIResponse) => {
        this.data.next(data);
      },
      (error) => {
        this.data.next(this.emptyResponse);
        if (error.status !== 401) {
          this.alertService.error(error.message);
        }
      }
    );
  }
}
